import moment from "moment";
import {
  // LEAVE_STATUS,
  STATUS_CODE,
  LEAVE_TYPE,
  authRole,
  RoutePermittedRole,
} from "shared/constants/AppConst";

export const createRoutes = (routeConfigs) => {
  let allRoutes = [];
  routeConfigs.forEach((config) => {
    allRoutes = [...allRoutes, ...setRoutes(config)];
  });
  return allRoutes;
};

export const setRoutes = (config) => {
  let routes = [...config.routes];
  if (config.auth) {
    routes = routes.map((route) => {
      let auth = route.auth
        ? [...config.auth, ...route.auth]
        : [...config.auth];
      return { ...route, auth };
    });
  }

  return [...routes];
};

export const getBreakPointsValue = (valueSet, breakpoint) => {
  if (typeof valueSet === "number") return valueSet;
  switch (breakpoint) {
    case "xs":
      return valueSet.xs;
    case "sm":
      return valueSet.sm || valueSet.xs;
    case "md":
      return valueSet.md || valueSet.sm || valueSet.xs;
    case "lg":
      return valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs;
    default:
      return (
        valueSet.xl || valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs
      );
  }
};

export const getFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  let k = 1024,
    dm = 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const multiPropsFilter = (products, filters, stringKey = "title") => {
  const filterKeys = Object.keys(filters);
  return products.filter((product) => {
    return filterKeys.every((key) => {
      if (!filters[key].length) return true;
      // Loops again if product[key] is an array (for material attribute).
      if (Array.isArray(product[key])) {
        return product[key].some((keyEle) => filters[key].includes(keyEle));
      }
      if (key === stringKey) {
        return product[key].toLowerCase().includes(filters[key].toLowerCase());
      }
      return filters[key].includes(product[key]);
    });
  });
};

export const calculateDiffDays = (endDate, startDate) => {
  const diffInMs = new Date(endDate) - new Date(startDate);
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  return diffInDays + 1;
};
export const getCustomDateTime = (
  value = 0,
  unit = "days",
  format = "DD/MM/YYYY HH:MM:SS"
) => {
  if (value === 0) {
    return moment().format(format);
  } else {
    return moment().add(value, unit).format(format);
  }
};
export const getCustomDateFormat = (value = 0, format = "DD/MM/YYYY") => {
  if (value === "") {
    return false;
  }
  if (value === 0) {
    return moment().format(format);
  } else {
    return moment(value).format(format);
  }
};

export const getCustomDateTimeFormat = (value = 0, format = "DD-MM-YYYY hh:mm A") => {
  if (value === "") {
    return false;
  }
  if (value === 0) {
    return moment().format(format);
  } else {
    return moment(value).format(format);
  }
};

export const convertToProperText = (text) => {
  if (typeof text === "string") {
    if (text.includes("_")) {
      let splitText = text.split("_");
      // let newSplit = splitText.map(
      //     (el) =>
      //         el.substring(0, 1) +
      //         el.substring(1, el.length)?.toLowerCase()
      // );
      return splitText.join(" ");
    }
    if (text.includes("-")) {
      let splitText = text.split("-");
      // let newSplit = splitText.map(
      //     (el) =>
      //         el.substring(0, 1) +
      //         el.substring(1, el.length)?.toLowerCase()
      // );
      return splitText.join(" ");
    }
    return text;
  }
};

//  Label change: Member = Sevak, Manager = Pramukh, Location Manager = Location Mukhya Sevak
export const changeRoleLabel = (role) => {
  if (role === RoutePermittedRole.MEMBER) {
    return "SEVAK";
  }
  if (role === RoutePermittedRole.MANAGER) {
    return "PRAMUKH";
  }
  if (role === RoutePermittedRole.LOCATION_MANAGER) {
    return "Location Mukhya Sevak";
  }
  if (role === RoutePermittedRole.HR_MANAGER) {
    return "HR Pramukh";
  }
  if (role === RoutePermittedRole.FINANCE_MANAGER) {
    return "Finance Pramukh";
  }
  return role;
};

// export const convertKeyToText = (statusCode) => {
//     let index = LEAVE_STATUS.findIndex((el) => el.key === statusCode);
//     if (index > -1) {
//         return LEAVE_STATUS[index].label;
//     }
//     return statusCode;
// };

export const isLeaveEditable = (item, user) => {
  if (item?.createdBy.includes(user.uid)) {
    // CHECK IF USER IS THE OWNER OF REQUEST
    // CASE : PERSONAL LEAVE
    if (item.leaveType === LEAVE_TYPE.PERSONAL_LEAVE) {
      // MEMBER
      if (user.role === authRole.MEMBER[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_RM ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }

      // DOCTOR
      if (user.role === authRole.DOCTOR[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_HR ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
      // MANAGER / FINANCE_MANAGER
      if (
        user.role === authRole.MANAGER[0] ||
        user.role === authRole.FINANCE_MANAGER[0]
      ) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_HR ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
      // HR_MANAGER
      if (user.role === authRole.HR_MANAGER[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_ADMIN ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
    }
    // CASE : SICK LEAVE
    if (item.leaveType === LEAVE_TYPE.SICK_LEAVE) {
      // MEMBER
      if (user.role === authRole.MEMBER[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_DOCTOR ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
      // DOCTOR
      if (user.role === authRole.DOCTOR[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_HR ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
      // MANAGER / FINANCE_MANAGER
      if (
        user.role === authRole.MANAGER[0] ||
        user.role === authRole.FINANCE_MANAGER[0]
      ) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_DOCTOR ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
      // HR_MANAGER
      if (user.role === authRole.HR_MANAGER[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_DOCTOR ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
    }
    // CASE : ON SEVA
    if (item.leaveType === LEAVE_TYPE.ON_SEVA) {
      // MEMBER
      if (user.role === authRole.MEMBER[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_RM ||
          item?.statusCode === STATUS_CODE.CONCERNED
        );
      }
      // MANAGER / FINANCE_MANAGER / DOCTOR
      if (
        user.role === authRole.MANAGER[0] ||
        user.role === authRole.FINANCE_MANAGER[0] ||
        user.role === authRole.DOCTOR[0]
      ) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_RM ||
          item?.statusCode === STATUS_CODE.CONCERNED ||
          item?.statusCode === STATUS_CODE.PENDING_WITH_HR
        );
      }
      // HR_MANAGER
      if (user.role === authRole.HR_MANAGER[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_RM ||
          item?.statusCode === STATUS_CODE.CONCERNED ||
          item?.statusCode === STATUS_CODE.PENDING_WITH_ADMIN
        );
      }
    }

    return false;
  }
  return false;
};
export const isLeaveDeletable = (item, user) => {
  if (item?.createdBy.includes(user.uid)) {
    // CHECK IF USER IS THE OWNER OF REQUEST
    // CASE : PERSONAL LEAVE
    if (item.leaveType === LEAVE_TYPE.PERSONAL_LEAVE) {
      // MEMBER / DOCTOR
      if (user.role === authRole.MEMBER[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_RM;
      }
      // MANAGER / FINANCE_MANAGER /DOCTOR
      if (
        user.role === authRole.MANAGER[0] ||
        user.role === authRole.FINANCE_MANAGER[0] ||
        user.role === authRole.DOCTOR[0]
      ) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_HR;
      }
      // HR_MANAGER
      if (user.role === authRole.HR_MANAGER[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_ADMIN;
      }
    }

    // CASE : SICK LEAVE
    if (item.leaveType === LEAVE_TYPE.SICK_LEAVE) {
      // MEMBER
      if (user.role === authRole.MEMBER[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_DOCTOR;
      }
      // DOCTOR
      if (user.role === authRole.DOCTOR[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_HR;
      }
      // MANAGER / FINANCE_MANAGER / HR_MANAGER
      if (
        user.role === authRole.MANAGER[0] ||
        user.role === authRole.FINANCE_MANAGER[0] ||
        user.role === authRole.HR_MANAGER[0]
      ) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_DOCTOR;
      }
    }
    // CASE : ON SEVA
    if (item.leaveType === LEAVE_TYPE.ON_SEVA) {
      // MEMBER
      if (
        user.role === authRole.MEMBER[0] ||
        user.role === authRole.DOCTOR[0]
      ) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_RM;
      }
      // MANAGER / FINANCE_MANAGER / DOCTOR
      if (
        user.role === authRole.MANAGER[0] ||
        user.role === authRole.FINANCE_MANAGER[0] ||
        user.role === authRole.DOCTOR[0]
      ) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_RM ||
          item?.statusCode === STATUS_CODE.PENDING_WITH_HR
        );
      }
      // HR_MANAGER
      if (user.role === authRole.HR_MANAGER[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_RM ||
          item?.statusCode === STATUS_CODE.PENDING_WITH_ADMIN
        );
      }
    }

    return false;
  }
  return false;
};
export const isLeaveCancellable = (item, user) => {
  if (
    item?.createdBy.includes(user.uid) &&
    !item?.pendingWith?.includes(user.uid)
  ) {
    return !(
      item?.statusCode === STATUS_CODE.REJECTED ||
      item?.statusCode === STATUS_CODE.CANCELLED ||
      item?.statusCode === STATUS_CODE.PENDING_WITH_FINANCE ||
      item?.statusCode === STATUS_CODE.REIMBURSED
    );
  }
  return false;
};
export const isLeaveCompletable = (item, user) => {
  if (item?.createdBy.includes(user.uid)) {
    return item?.statusCode === STATUS_CODE.APPROVED;
  }
  return false;
};
export const isLeaveReimbursable = (item, user) => {
  if (item?.createdBy.includes(user.uid)) {
    return item?.statusCode === STATUS_CODE.COMPLETED;
  }
  return false;
};
export const isLeaveReimbursmentClose = (item, user) => {
  if (item?.createdBy !== user.uid) {
    return item?.statusCode === STATUS_CODE.PENDING_WITH_FINANCE;
  }
  return false;
};

export const isActionVisible = (item, user) => {
  console.log("🚀 ~ Utils.js:376 ~ isActionVisible ~ item, user:", item, user);
  if (!isEmptyObject(item)) {
    if (!item?.createdBy.includes(user.uid)) {
      // APPROVER : DOCTOR
      if (user.role === authRole.DOCTOR[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_DOCTOR;
      }
      // APPROVER : MANAGER
      if (
        user.role === authRole.MANAGER[0] &&
        item.statusCode == STATUS_CODE.PENDING_WITH_RM
      ) {
        // BECUASE WE CAN HAVE MULTIPLE MANAGER APPROVAL
        const pendingWithArr =
          item.pendingWith !== null && item.pendingWith.split(",");
        if (pendingWithArr.length > 0) {
          // const isApprovedByMe = pendingWithArr.includes(user.uid);
          const isApprovedByMe = pendingWithArr.some((item) =>
            item.includes(user.uid)
          );
          return isApprovedByMe;
        }
        return item?.statusCode == STATUS_CODE.PENDING_WITH_RM;
      }
      // APPROVER : HR_MANAGER
      if (user.role === authRole.HR_MANAGER[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_HR;
      }
      // APPROVER : FINANCE
      if (user.role === authRole.FINANCE_MANAGER[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_RM;
      }
      // APPROVER : SETUP_MANAGER
      if (user.role === authRole.SETUP_MANAGER[0]) {
        return item?.statusCode === STATUS_CODE.PENDING_WITH_RM;
      }
      // APPROVER : ADMIN
      if (user.role === authRole.ADMIN[0]) {
        return (
          item?.statusCode === STATUS_CODE.PENDING_WITH_ADMIN ||
          item?.statusCode === STATUS_CODE.APPROVED_BY_DOCTOR
        );
      }
      // OTHERS
      return false;
    } else {
      if (item?.pendingWith?.includes(user.uid)) {
        // APPROVER : HR_MANAGER
        if (user.role === authRole.HR_MANAGER[0]) {
          return item?.statusCode === STATUS_CODE.PENDING_WITH_HR;
        }
      }
    }
  }
  // OTHERS
  return false;
};

export const timeFromNow = (date) => {
  const timestamp = moment(date).format("X");
  const newDate = moment.unix(timestamp);
  return moment(newDate).fromNow();
};

export const checkPermission = (routeAuth, userRole) => {
  if (routeAuth === null || routeAuth === undefined) {
    return true;
  }

  if (userRole && Array.isArray(userRole)) {
    return routeAuth.some((r) => userRole.indexOf(r) >= 0);
  }

  if (routeAuth.length === 0) {
    return !userRole || userRole.length === 0;
  }
  if (userRole && Array.isArray(userRole) && Array.isArray(routeAuth)) {
    return routeAuth.some((r) => userRole.indexOf(r) >= 0);
  }
  return routeAuth.indexOf(userRole) >= 0;
};

export const generateUniqueID = () => {
  return `v1-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

export const getUserFromAuth0 = (user) => {
  if (user)
    return {
      id: 1,
      uid: user.sub,
      displayName: user.name,
      email: user.email,
      photoURL: user.picture,
      role: user.userRole,
    };
  return user;
};

export const getUserFromFirebase = (user) => {
  if (user)
    return {
      id: 1,
      uid: user.uid,
      displayName: user.displayName ? user.displayName : "Crema User",
      email: user.email,
      photoURL: user.photoURL,
      role: user.userRole,
    };
  return user;
};
export const getUserFromAWS = (user) => {
  if (user)
    return {
      id: 1,
      uid: user.username,
      displayName: user.attributes.name ? user.attributes.name : "Crema User",
      email: user.attributes.email,
      photoURL: user.photoURL,
      role: user.userRole,
    };
  return user;
};
export const getUserFromJwtAuth = (user) => {
  if (user)
    return {
      id: 1,
      uid: user._id,
      displayName: user.name,
      email: user.email,
      photoURL: user.avatar,
      role: user.userRole,
    };
  return user;
};
export const textEllipsis = (text, length = 50) => {
  if (text?.length > 50) {
    return text.slice(0, length) + "...";
  } else {
    return text;
  }
};

// IS OBJECT EMPTY
export const isEmptyObject = (objectName) => {
  for (let prop in objectName) {
    if (objectName.hasOwnProperty.call(objectName, prop)) {
      return false;
    }
  }
  return true;
};

// contentType: The content type of your file.
//              its like application/pdf or application/msword or image/jpeg or
//              image/png and so on
// base64Data: Its your actual base64 data
// fileName: Its the file name of the file which will be downloaded.
export const downloadFile = (contentType, fileName, data) => {
  const linkSource = "data:" + contentType + ";base64," + data;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};
export const isObjectEmpty = (objectName) => {
  if (typeof objectName == "undefined") {
    return true;
  } else {
    return (
      objectName &&
      Object.keys(objectName).length === 0 &&
      objectName.constructor === Object
    );
  }
};
// check other case in leave
export const isCheckOtherLocation = (arr, string) => {
  let res = arr.some((item) => item.location.includes(string));
  return res;
};

export const getFileExtension = (filename) => {
  return filename.split(".").pop();
};

export const haveCreatePermission = (user) => {
  if (user.roles.length > 1) {
    if (
      user.roles.includes(RoutePermittedRole.MEMBER) &&
      user.role === RoutePermittedRole.MEMBER
    ) {
      return true;
    }
    if (
      user.roles.includes(RoutePermittedRole.MANAGER) &&
      !user.roles.includes(RoutePermittedRole.MEMBER) &&
      user.role === RoutePermittedRole.MANAGER
    ) {
      return true;
    }
    return false;
  }
  return true;
};
